import React from "react";

// The signed-in user as our database has them (name, email), shared so the
// header avatar follows a name change made on the account page without a
// reload. The header fills it from /api/me; this module never fetches.
let cached = null;
const listeners = new Set();

export function setMyUser(user) {
  cached = user || null;
  listeners.forEach((fn) => fn(cached));
}

// useMyUser returns the user, or null until /api/me has loaded.
export default function useMyUser() {
  const [user, setUser] = React.useState(cached);
  React.useEffect(() => {
    listeners.add(setUser);
    setUser(cached);
    return () => { listeners.delete(setUser); };
  }, []);
  return user;
}
